import { NavLink } from "react-router-dom";
import { useContext } from 'react';

import './styles.scss';
import { LanguageContext, localize } from '../Localization'

export default function Links(props) {
  const { style } = props;
  const language = useContext(LanguageContext)

  return (
    <div className='Links' style={style}>
      <div className='link'>
        <NavLink
          key='SchoolSiteBudgets'
          to='SchoolSiteBudgets'
          activeClassName='active'
        >
          <div className='button'>
            <span>
            {localize(language, 'school site budgets', 'title')}
            </span>
          </div>
        </NavLink>
      </div>
      <div className='link'>
        <NavLink
          key='CentralSupportsandAdmin'
          to='CentralSupportsandAdmin'
          activeClassName='active'
        >
          <div className='button'>
            <span>
            {localize(language, 'central supports and admin', 'title')}
            </span>
          </div>
        </NavLink>
      </div>
    </div>
  );
}
